import { createSelector } from 'reselect';

import { selectVideo } from './videoPlayer';

export const selectEmojiOrCommentOnBar = createSelector(selectVideo, video =>
  Boolean(
    video.use_emojis ||
      (video.comments_enabled && video.rollout_timeline_comments)
  )
);

export const selectCommentsEnabled = createSelector(
  selectVideo,
  video => video.comments_enabled
);

export const selectEmojiEnabled = createSelector(
  selectVideo,
  video => video.use_emojis
);

export const selectRolloutTimelineComments = createSelector(
  selectVideo,
  video => video.rollout_timeline_comments
);
